var _module = require('../../components/module');

require('angular-ui-bootstrap/src/modal');
require('../lr-touch');

_module.requires.push('ui.bootstrap.module.modal');

_module.service('$errorModal', [
    '$log',
    '$uibModal',

    function $errorModal($log, $uibModal) {
        return function openErrorModal(message, options) {
            options = options || {};
            var modal = $uibModal.open({
                animation: false,
                template: require('./index.html'),
                controller: [
                    '$scope',

                    function errorCtrl($scope) {
                        $scope.message = message || 'Looks like something went wrong. Please try again and contact support@listreports.com if the problem continues.';
                        $scope.title = options.title || 'Oops!';
                        $scope.buttonLabel = options.buttonLabel || 'Ok';
                    }
                ],
                backdrop: true,
                windowClass: 'error-modal'
            });

            return modal;
        };
    }
]);
